import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { brandOrange, brandWhite } from '../../../assets/consts/color'
import IconCheverone from '../../../assets/images/icon-cheveron-up.svg'
import useClickOutside from '../../../hooks/useClickOutside'
import CustomizeRadioItem from './CustomizeItem'

const SettingsContainer = styled.div`
  position: relative;
  min-width: 183px;

  border: 2px solid ${brandOrange};

  color: ${brandWhite};
  cursor: pointer;

  p {
    padding: 8px 30px 8px 15px;
    color: ${brandWhite};
    font-size: 14px;
    line-height: 120%;
    margin: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 8px;
    display: block;
    width: 16px;
    height: 16px;

    background-image: url(${IconCheverone});
    background-size: contain;
    transform: translateY(-50%) ${({ open }) => open && 'rotate(180deg)'};
    pointer-events: none;
  }
`

const SettingsDropdown = styled.div`
  position: absolute;
  width: 100%;
  bottom: 110%;
  padding: 16px;
  background-color: ${brandWhite};
  cursor: default;

  ul {
    display: grid;
    gap: 16px;
    margin: 0;
    padding: 0;

    li {
      margin: 0;
    }
  }
`

function CustomizeSettings({ settings, onSelect }) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const handleSettingsOpen = () => {
    setIsSettingsOpen(!isSettingsOpen)
  }

  const handleChangeRadioItem = (e) => {
    onSelect(
      settings.map(({ label, value }) => ({
        label,
        value: label === e.target.name ? !value : value,
      }))
    )
  }

  useClickOutside(dropdownRef, () => setIsSettingsOpen(false))

  return (
    <SettingsContainer ref={dropdownRef} open={isSettingsOpen}>
      <p onClick={handleSettingsOpen}>Customise Settings</p>

      {isSettingsOpen && (
        <SettingsDropdown>
          <ul>
            {settings.length > 0 &&
              settings.map(({ label, value }) => (
                <li key={label}>
                  <CustomizeRadioItem
                    label={label}
                    name={label}
                    checked={value}
                    disabled={label === 'essential'}
                    onChange={handleChangeRadioItem}
                  />
                </li>
              ))}
          </ul>
        </SettingsDropdown>
      )}
    </SettingsContainer>
  )
}

export default CustomizeSettings
